import { useQuery } from '@apollo/react-hooks';
import { useRegistryShoppingClient } from '../apollo/ApolloClientsProvider';
import { gql } from 'apollo-boost';

const GET_CATEGORY_PRODUCTS = gql`
  query getCategoryProducts(
    $id: String!
    $pageSize: Int
    $after: String
    $filter: ProductFilterParameter
    $sort: ProductSortParameter
    $exclusions: ProductExclusionParameter
  ) {
    category(id: $id) {
      products(first: $pageSize, after: $after, filter: $filter, sort: $sort, exclusions: $exclusions) {
        edges {
          node {
            id
            award
            sku
            name
            brand
            url
            reviews {
              avgRating
              totalCount
            }
            priceRange {
              min
              max
            }
            options {
              key
              label
              values {
                label
                value
                swatch {
                  type
                  value
                }
              }
            }
            mostSpecificCategory {
              url
              name
              breadcrumbs {
                name
              }
            }
            variants {
              id
              name
              sku
              upc
              productType
              color
              offer {
                id
                quantity
                price
              }
              mediaGallery {
                url
              }
              smallImage {
                url
              }
              selectedOptions {
                key
                label
                value
              }
            }
          }
        }
        totalCount
      }
    }
  }
`;

export const useGetRegistryProducts = (categoryId = '2', price = '*_49.99') => {
  const client = useRegistryShoppingClient();

  const result = useQuery(GET_CATEGORY_PRODUCTS, {
    client,
    variables: {
      id: categoryId,
      pageSize: 9,
      filter: {
        facets: [
          {
            key: 'price',
            values: [price],
          },
        ],
      },
    },
    skip: false,
  });

  return result;
};
